import type { Credential, LedgerStat } from '../types/content'
import { articles } from './articles'

export const ledgerStats: LedgerStat[] = [
  { value: '300+', label: 'Engineering organizations measured' },
  {
    value: String(articles.length),
    label: 'Published articles, 2016 to 2026',
  },
  { value: 'YC W21', label: 'Accepted on the 13th application' },
  { value: '1', label: 'Granted USPTO patent in Git analytics' },
]

export const organizations: string[] = [
  'American Express',
  'Caterpillar',
  'Dropbox',
  'PwC',
  'Citi Ventures',
  'Capgemini',
  'Sovos',
  'TATA Health',
]

export const outcomes: { value: string; label: string }[] = [
  { value: '28%', label: 'Cycle time improvement' },
  { value: '21%', label: 'Reduction in unplanned work' },
  { value: '28%', label: 'Decrease in code churn' },
]

export const credentials: Credential[] = [
  {
    source: 'Y Combinator W21.',
    detail:
      'Accepted after thirteen applications, one of the first Romanian founders in the program.',
  },
  {
    source: 'Gartner.',
    detail:
      'Representative Vendor in the Software Engineering Intelligence Market Guide.',
  },
  {
    source: 'G2.',
    detail: 'Consistent Leader in Software Development Analytics.',
  },
  {
    source: 'USPTO.',
    detail: 'Granted patent covering Git analytics methodology.',
  },
  {
    source: 'HackerNoon.',
    detail: 'Contributor of the Year, Agile and Engineering Management.',
  },
  {
    source: 'Forbes Technology Council.',
    detail: 'Member and contributor.',
  },
]
